import { useState, useEffect, useContext } from 'react';
import DeadlineModalContext from '../../modules/contexts/DeadlineModalContext';
import {
  getOptionGroup,
  getDeadline,
} from '../../domain/Sales/Item/BabyfaceAPI';
import TEXT from '../../lib/text/textSalesBabyface.json';
import { LocalDateTimeToMMDDHH } from '../../lib/util/Date';

const useBabyfaceSales = ({ babyface }) => {
  const isActiveCampaigns = babyface.activeCampaigns.length > 0;
  const [salesOptions, setSalesOptions] = useState(null);
  const [deadline, setDeadline] = useState(null);

  useEffect(() => {
    if (babyface !== null) {
      sessionStorage.itemId = babyface.id;
      getOptionGroup({ id: babyface.id }).then((response) => {
        setSalesOptions(response);
      });
    }
  }, []);

  useEffect(() => {
    getDeadline().then((response) => {
      setDeadline(response);
    });
  }, []);

  const doGetDeadlineBody = () => {
    const {
      fastConversionDeadline,
      fastDeliveryDeadline,
      defaultConversionDeadline,
      defaultDeliveryDeadline,
    } = deadline;

    const transDate = (dateArr) => {
      return dateArr.map((item) => LocalDateTimeToMMDDHH(item));
    };

    return [
      [textFastConversion, [fastConversionDeadline, fastDeliveryDeadline]],
      [
        textDefaultConversion,
        [defaultConversionDeadline, defaultDeliveryDeadline],
      ],
    ].map((item) => [item[0]].concat(transDate(item[1])));
  };

  /** 배송 관련 공지 */
  const {
    actions: { doShowModal },
  } = useContext(DeadlineModalContext);

  useEffect(() => {
    doShowModal(true);
  }, []);

  return {
    isActiveCampaigns,
    salesOptions,
    deadline,
    doGetDeadlineBody,
  };
};

export default useBabyfaceSales;

const { textFastConversion, textDefaultConversion } = TEXT;
